import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { compose } from 'recompose'
import { modal, wizard } from 'helpers/decorators'
import { Checkbox, Textarea } from 'components/fields'
import { Title, Note, FormDebug, Button, AssessorFileCard, FieldError } from 'components/misc'
import { FormattedMessage } from 'react-intl'
import { apiAssessors } from 'helpers/decorators/api'
import queryString from 'query-string'
import validate from './activity.validation'
import { AssessorFileUploadModal, AssessorFileDeleteModal } from '../../../../components/modals'
import MODALS from '../../../../constants/layout/modals'
import { ElevatedButton } from '../../../../components/layout'
import { FileLoader } from '../../../../components/loaders'
import styles from './activity.styl'

const enhance = compose(
  apiAssessors(),
  modal.trigger(),
  wizard({
    form: 'assessorRegistration',
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  connect(state => ({
    data: get(state.api.assessor.profile, 'data', {}),
    fileUploading: state.api.blob.loading,
    files: get(state.api.assessor.registration.files, 'data', []),
    filesLoading: get(state.api.assessor.registration.files, 'loading'),
    submitFailed: get(state.form, 'assessorRegistration.submitFailed'),
  }), { push })
)

class Activity extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    errors: PropTypes.object,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    onUploadAssessorFile: PropTypes.func,
    onLoadAssessorFile: PropTypes.func,
    onLoadFilesForActivityRegistration: PropTypes.func,
    onDeleteAssessorFile: PropTypes.func,
    fileUploading: PropTypes.bool,
    filesLoading: PropTypes.bool,
    files: PropTypes.array,
    modalObj: PropTypes.object
  }

  async componentDidMount() {
    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    authCode && this.props.onLoadFilesForActivityRegistration(authCode)
  }

  getData = data => {
    let preparedData = {}

    preparedData.assessorId = get(data, 'assessor.id')
    preparedData.organizationName = get(data, 'assessor.organization.name') || get(data, 'assessorActivityCategoryRegistration.activity.award.organization.name')
    preparedData.participantName = get(data, 'assessorActivityCategoryRegistration.activity.award.participant.name')

    if (get(data, 'assessorActivityCategoryRegistration.activity')) {
      preparedData.activityId = get(data, 'assessorActivityCategoryRegistration.activity.id')

      preparedData.activitySection = get(data, 'assessorActivityCategoryRegistration.activity.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'assessorActivityCategoryRegistration.activity.activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'assessorActivityCategoryRegistration.activity.activityCategory.parent.translatedName')
    }

    if (get(data, 'assessorActivityCategoryRegistration.activityCategory')) {
      preparedData.activityCategoryId = get(data, 'assessorActivityCategoryRegistration.activityCategory.id')
      preparedData.activitySection = get(data, 'assessorActivityCategoryRegistration.activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = get(data, 'assessorActivityCategoryRegistration.activityCategory.translatedName')
      preparedData.activityCategory = get(data, 'assessorActivityCategoryRegistration.activityCategory.parent.translatedName')
    }

    if (get(data, 'assessorActivityCategoryRegistration.ajEvent')) {
      preparedData.ajEventId = get(data, 'assessorActivityCategoryRegistration.ajEvent.id')
      preparedData.activitySection = preparedData.activitySection || get(data, 'assessorActivityCategoryRegistration.ajEvent.activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = preparedData.activitySubCategory || get(data, 'assessorActivityCategoryRegistration.ajEvent.activityCategory.translatedName')
      preparedData.activityCategory = preparedData.activityCategory || get(data, 'assessorActivityCategoryRegistration.ajEvent.activityCategory.parent.translatedName')
    }

    if (get(data, 'assessorActivityCategoryRegistration.residentialProject')) {
      preparedData.residentialProjectId = get(data, 'assessorActivityCategoryRegistration.residentialProject.id')
      preparedData.activitySection = preparedData.activitySection || get(data, 'assessorActivityCategoryRegistration.residentialProject.activityCategory.activitySection.translationText')
      preparedData.activitySubCategory = preparedData.activitySubCategory || get(data, 'assessorActivityCategoryRegistration.residentialProject.activityCategory.translatedName')
      preparedData.activityCategory = preparedData.activityCategory || get(data, 'assessorActivityCategoryRegistration.residentialProject.activityCategory.parent.translatedName')
    }

    return preparedData
  }


  render() {
    const {
      data,
      handleSubmit,
      values,
      errors,
      fileUploading,
      filesLoading,
      files,
      modalObj,
      onSubmit
    } = this.props

    const preparedData = this.getData(data)

    const organizationName = get(preparedData, 'organizationName')

    const participantName = get(preparedData, 'participantName')

    const activitySection = get(preparedData, 'activitySection')

    const activitySubCategory = get(preparedData, 'activitySubCategory')

    const activityCategory = get(preparedData, 'activityCategory')

    const activityCategoryId = get(preparedData, 'activityCategoryId')

    const activityId = get(preparedData, 'activityId')

    const ajEventId = get(preparedData, 'ajEventId')

    const residentialProjectId = get(preparedData, 'residentialProjectId')

    const assessorRegistrationId = get(data, 'id')

    const id = activityId || ajEventId || residentialProjectId || activityCategoryId

    const assessorId = get(preparedData, 'assessorId')

    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    const qualificationsError = errors?.peakBody

    const submitFailed = get(this.props, 'submitFailed')

    const withoutAssessor = true

    return (
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
        <Title intlKey="moduleTitle.activity_details" h2>
          Activity Details
        </Title>

        <div className="row">
          {organizationName && participantName &&  <Note hideNodePrefix={true} margin="0 0 0 15px">
        <FormattedMessage
          id="label.desc_au_and_participant"
          defaultMessage="{organizationName} for participant {participantName}"
          values={{
            organizationName,
            participantName
          }}
        />
          </Note>}
        <br />
          <Note hideNodePrefix={true} margin="0 0 40px 15px">
          <FormattedMessage
            id="label.desc_activity_detail"
            defaultMessage="For {activitySection} - {activityCategory} - {activitySubCategory}"
            values={{
              activitySection,
              activityCategory,
              activitySubCategory
            }}
          />
          </Note>
        </div>

        <Note hideNodePrefix={true} lighter margin="0 0 10px 0">
          <FormattedMessage
            id="label.all_qualifications_currently_hold"
            defaultMessage="Please tick all qualifications you currently hold."
          />
        </Note>

        <div className="row">
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.universityDegree"
              label="University Degree"
              intlKey="label.university_degree"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.tafeQualification"
              label="TAFE Qualification"
              intlKey="label.tafe_qualification"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.apprenticeship"
              label="Apprenticeship"
              intlKey="label.apprenticeship"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.experience"
              label="Work Experience"
              intlKey="label.work_experience"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.membership"
              label="Membership"
              intlKey="label.membership"
            />
            <FieldError className={styles.qualificationsError} toShow={submitFailed} message={qualificationsError} />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.nonAccreditedTraining"
              label="Non-accredited Training"
              intlKey="label.non_accredited_training"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.organisational"
              label="Organisational"
              intlKey="label.organisational"
            />
          </div>
          <div className="col-md-3">
            <Checkbox
              name="assessorActivityCategoryRegistration.peakBody"
              label="Peak Body"
              intlKey="label.peak_body"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-12">
            <Textarea
              name="assessorActivityCategoryRegistration.relevantExperience"
              label="Please enter all relevant experience you have to support the activities you will be assessing (200 characters)*"
              intlKey="label.relevant_experience_desc"
              maxLength={200}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-12">
            <Checkbox
              name="assessorActivityCategoryRegistration.isPublicAvailable"
              label="I am happy to assess activities for other participants -> if no then you are not listed among assessor."
              intlKey="label.i_am_happy_to_assess_other_participants_activities"
            />
          </div>
        </div>
        <div>
        <p className="note">
          <FormattedMessage
            id="label.assessor_registration_upload_file_with_assessed_activity"
            defaultMessage="You can upload here any files related with assessed activity."
          />
        </p>
        {!filesLoading.loading ? (
          <div className="row">
            {files && files.map(item => (
                <div key={item.id} className="col-xs-12 col-sm-6">
                  <AssessorFileCard
                    src={item.fileUrl}
                    file={item}
                    fileId={item.id}
                    onDeleteClick={() =>
                      this.props.onOpen(MODALS.ASSESSOR_FILE_DELETE, null, {
                        id,
                        assessorId,
                        item,
                        authCode,
                        withoutAssessor
                      })
                    }
                  />
                </div>
              ))
              .reverse()
            }
          </div>
        ) : (
          <FileLoader />
        )}

        <ElevatedButton
          onClick={() => this.props.onOpen(MODALS.ASSESSOR_FILE_UPLOAD)}
          intlKey="button.upload_file"
          rounded
          uppercase
        >
          Upload file
        </ElevatedButton>
        </div>
        <br />
        <FormDebug values={values} />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>

      <AssessorFileUploadModal
        modalId={MODALS.ASSESSOR_FILE_UPLOAD}
        onSubmit={this.props.onUploadAssessorFile}
        assessorId={assessorId}
        activityId={activityId}
        ajEventId={ajEventId}
        activityCategoryId={activityCategoryId}
        residentialProjectId={residentialProjectId}
        authCode={authCode}
        loading={fileUploading}
        withoutAssessor={withoutAssessor}
        assessorRegistrationId={assessorRegistrationId}
      />
      <AssessorFileDeleteModal
          modalId={MODALS.ASSESSOR_FILE_DELETE}
          onClose={this.props.onClose}
          onConfirm={() => this.props.onDeleteAssessorFile(modalObj.data)}
       />
     </div>
    )
  }
}

export default enhance(Activity)

